// src/utils/googleAnalytics.ts
import ReactGA from 'react-ga4'

const measurementId = 'G-BH1Q9W9RP6' // Replace with your Measurement ID

export const initGA = () => {
  ReactGA.initialize(measurementId)
}

export const trackPageview = (url: string) => {
  ReactGA.send({ hitType: 'pageview', page: url })
}
export const trackFunnelStep = (step: string) => {
  ReactGA.event({
    category: 'Booking Funnel',
    action: 'Step Reached',
    label: step,
  })
}
export const trackEvent = (
  action: string,
  category: string,
  label?: string
) => {
  ReactGA.event({
    action,
    category,
    label,
  })
}
